import { render } from "./pro-spec.vue?vue&type=template&id=686f8691&scoped=true"
import script from "./pro-spec.vue?vue&type=script&lang=js"
export * from "./pro-spec.vue?vue&type=script&lang=js"

import "./pro-spec.vue?vue&type=style&index=0&id=686f8691&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-686f8691"

export default script